// httpClient.js
import axios from 'axios';
import { config } from './config';


const PROD_BACK = config.backend;
const MICR_SERV = config.microservice;
const tabUrl = config.tabUrl;

const httpClient = axios.create({
  baseURL: PROD_BACK
});

const testhttpClient = axios.create({
  baseURL: MICR_SERV
});

const dummyhttpClient = axios.create({
  baseURL: 'http://quote.cloobot.ai:5003/'
});


export const dynApi = (api) =>{
  const dynHttpClient = axios.create();
  return dynHttpClient;
}

export default httpClient;
export {testhttpClient};
export {dummyhttpClient};
export {PROD_BACK};
export {tabUrl};

